import React, { FormEvent, useState } from "react";
import BaseModal from "@admin/components/Modal";
import Input from "@admin/components/Input";
import { getSbpAdditionalPayment, type SbpAdditionalPaymentData } from "@admin/domain/orders/api";
import { useLoaderContext } from "@admin/components/LoaderContext";

type Props = {
    orderId: number;
    closeModal: () => void;
};

export default function SbpAdditionalPaymentModal({ orderId, closeModal }: Props) {
    const { isLoading, request } = useLoaderContext();
    const [payment, setPayment] = useState<SbpAdditionalPaymentData | null>(null);

    const submit = async (event: FormEvent): Promise<void> => {
        event.preventDefault();

        const form = event.target as HTMLFormElement;
        const amount = Number(new FormData(form).get(`amount`));

        request(async (): Promise<void> => {
            const data = await getSbpAdditionalPayment(orderId, amount);
            setPayment(data);
        });
    };

    const copyToClipboard = async (): Promise<void> => {
        if (payment?.payload) {
            await navigator.clipboard.writeText(payment.payload);
        }
    };

    return (
        <BaseModal
            closeModal={closeModal}
            title="Доплата СБП"
            body={
                <>
                    <form onSubmit={submit} id="sbp_additional_payment_form">
                        <Input
                            label="Сумма доплаты (руб.)"
                            name="amount"
                            type="number"
                            step="0.01"
                            min="0.01"
                            required
                        />
                    </form>

                    {payment?.payload && (
                        <div className="border rounded p-5 mt-5">
                            <div className="fw-bolder mb-3">Ссылка для оплаты доплаты</div>
                            <a className="d-block mb-3 text-break" href={payment.payload} target="_blank" rel="noreferrer">
                                {payment.payload}
                            </a>
                            {payment.qr_url && (
                                <img
                                    className="d-block mb-3"
                                    src={payment.qr_url}
                                    alt="QR-код для оплаты доплаты"
                                    width={200}
                                />
                            )}
                            <button type="button" className="btn btn-info" onClick={copyToClipboard}>
                                Скопировать ссылку
                            </button>
                        </div>
                    )}
                </>
            }
            footer={
                <>
                    <button type="button" className="btn btn-secondary" onClick={closeModal}>
                        Закрыть
                    </button>
                    {!payment && (
                        <button
                            type="submit"
                            className="btn btn-primary"
                            form="sbp_additional_payment_form"
                            disabled={isLoading}
                        >
                            Сформировать ссылку
                        </button>
                    )}
                </>
            }
        />
    );
}
